
import React, { useEffect, useState } from 'react';
import { formatDate, formatPrice, timeDiff } from '../../utils/Common';

const TransactionHistoryItem = (props) => {
  const {
    transactionData,
    paymentList,
    paymentAccountList,
    activeTab,
    selectAllChecked,
    setAllFetchedData,
    allFetchedData,
    onSelect,
    index
} = props;

  const [isChecked, setIsChecked] = useState(false);

  // useEffect(() => {
  //   setIsChecked(selectAllChecked);
  // }, [selectAllChecked]);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    onSelect(index, transactionData);
  };

  const paymentData = paymentList.data ? paymentList.data : paymentList;
  const paymentAccountData = paymentAccountList.data ? paymentAccountList.data : paymentAccountList;

  const createdDate = new Date(transactionData?.date);

  return (
    <>
    {activeTab &&
      <div className="border-b-[1px] text-center text-sm border-solid  border-[#E7EBF4] py-[13px] font-nunito grid grid-cols-7 items-start">

        <div className='text-left'>
          <input
            type="checkbox"
            checked={transactionData.completed}
            onChange={handleCheckboxChange}
          />
        </div>

        <div className="text-left">
          <h1 className=" text-[#000] font-[600]">{formatDate(transactionData?.date)}</h1>
          <p className=" text-[#87889E] font-[500] text-sm">{timeDiff(createdDate)}</p>
        </div>

        <div className="text-[#000] font-[500] text-center">
          {transactionData.payment_method && transactionData.payment_method.map((item, index) => (
            (item.payment_type_category_id && item.payment_type_id) ? (

              paymentData.map((payment) => (
                (payment.id === item.payment_type_id) ? (
                  payment?.payment_type_category.map((account)=>(
                    ( account.id==item.payment_type_category_id) &&
                      (
                        <div className='w-20 mx-auto'>
                          <p key={index} className="text-[#000] font-[500] whitespace-nowrap text-left text-md">
                            {payment.type_name}
                          </p>
                          { String(payment?.type_name).toLowerCase() !='cash' &&
                          <p className='text-left'>{" "}{account.payment_category_name}<br/><span className='whitespace-nowrap text-[#FF0000]'>{"AC: "}{account.account_number}</span><br></br>
                            <span className='font-bold text-emerald-600'>{Number.parseFloat(item.payment_amount).toFixed(2)}{" BDT"}</span>
                          </p> }
                          <hr />
                        </div>
                      )
                      // : null
                  ))

                ) : null
              ))
            ) : (
              <div className='w-20 mx-auto'>
                <p key={index} className="text-[#000] text-left whitespace-nowrap font-[500] text-md">{"Cash-"}
                { item.payment_amount==null? 0 : <span className='font-bold text-emerald-600'>{Number.parseFloat(item.payment_amount).toFixed(2)}{" BDT"}</span>}
                </p>
                {/* { index<paymentData.length && date} */}
              </div>
            )
          ))}
        </div>


        <div className="text-[#000] font-semibold text-center">
          <p className="text-[#000] font-[500] text-md">{transactionData?.transaction_history?.transaction_status}</p>
        </div>


        <div className="text-[#000] font-[500] text-center">
          <p className="text-[#000] font-[500] text-md">{transactionData?.type}</p>
        </div>

        <div className=" text-[#000] font-[500] text-center ">{transactionData?.invoice}</div>

        <div className=" text-[#000] font-[500] text-right">{Number.parseFloat(transactionData?.total_paid).toFixed(2)}</div>
      </div>}
    </>
  );
};
TransactionHistoryItem.defaultProps = { className: null };
export default TransactionHistoryItem;